import {momentRange} from "../../../../../gd/convert/moment-range";
import {WorkItemReportTypeView} from "../../../../../../views/reports/time-reports/const";
import formatDaterange from "../../../../../gd/format/daterange";

export default class ReportProjectTimeReportByDate_Settings {

    public projectId            : ID | null
    public daterange            : DateRange
    public users                : ID[]
    public typeView             : WorkItemReportTypeView
    public hideEmptyWorkItems   : boolean
    public estimate             : boolean
    public timeReported         : boolean
    public spentEstimate        : boolean

    constructor(data: any) {
        this.daterange            = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "month"), moment())
        this.projectId            = _.get(data, "projectId", null)
        this.users                = _.get(data, "users", [])
        this.typeView             = _.get(data, "typeView", WorkItemReportTypeView.DAILY)
        this.hideEmptyWorkItems   = _.get(data, "hideEmptyWorkItems", true)
        this.estimate             = _.get(data, "estimate", false)
        this.timeReported         = _.get(data, "timeReported", false)
        this.spentEstimate        = _.get(data, "spentEstimate", false)
    }

    get reportTitle() {
        return formatDaterange(this.daterange)
    }

    toJSON(): JSONObject {
        const result: JSONObject = {
            projectId            : this.projectId,
            users                : this.users,
            typeView             : this.typeView,
            hideEmptyWorkItems   : this.hideEmptyWorkItems,
            estimate             : this.estimate,
            timeReported         : this.timeReported,
            spentEstimate        : this.spentEstimate
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
